import React from 'react';

import { Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import Modal from 'v3/components/Modal';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import { useRasterBranches } from '../../shared/context';

function Created({ isOpen, onClose }) {
  const rasterBranches = useRasterBranches();
  const navigate = useNavigate();

  return (
    <>
      <Modal
        size="lg"
        show={isOpen}
        onHide={onClose}
        heading="Cadastro filiais raster"
        body={
          <Row className="mx-0 mt-1">
            <Text weight="400" color="dark">
              Filial {rasterBranches.data.name} cadastrado com sucesso!
            </Text>
          </Row>
        }
        footer={
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button
              variant="white"
              outlined
              size="sm"
              onClick={() => navigate('/filiais-raster')}
            >
              <Text weight="500">Ver listagem</Text>
            </Button>

            <Button
              variant="primary"
              size="sm"
              onClick={() => navigate(`/filiais-raster/${rasterBranches?.data?.id}`)}
            >
              <Text weight="500">Visualizar</Text>
            </Button>

            <Button
              variant="success"
              size="sm"
              onClick={() => {
                window.location.reload(false);
              }}
            >
              <Text weight="500">Cadastrar novo</Text>
            </Button>
          </div>
        }
      />
    </>
  );
}

export default Created;
